import dayjs from 'dayjs';

export const dateDifferenceInDays = (fromDate: string | null, toDate?: string | null) => {
  if (!fromDate || !toDate) return 0;

  return dayjs(toDate).diff(fromDate, 'days');
};
